import { Observable, of } from 'rxjs';
import { ColumnDefinition } from './column-definition';

export class ExpandedListViewItemDefinition<TSource = any, TContext = TSource> {
  constructor() {}

  caption: string;
  columnDefinitions: ColumnDefinition[];
  dataContext: TContext;
  icon: string;
  itemsSource: TSource[];
  dataLoader: (dataContext: TContext) => Observable<TSource[]> = (dataContext: TContext) => {
    return of(this.itemsSource);
  };
}
